import api, {apiTs} from '../../../services/api';

export const PunchHTTP = {
  get: (params = {}) => api.get('/punches', {params}),
  create: (payload = {}) => apiTs.post('/punch', payload),
  update: (punchId = '', payload = {}) =>
    api.put(`/punches/${punchId}`, payload),
  updateHours: (punchId = '', payload = {}) =>
    apiTs.put(`/punch/${punchId}`, payload),
  updateHoursV1: (punchId = '', payload = {}) =>
    api.put(`/punches/update-boss/${punchId}`, payload),
  destroy: (punchId = '') => apiTs.delete(`/punch/${punchId}`),

  updateBossComment: (punchId = '', payload = '') =>
    api.put(`/boss-comments/${punchId}`, payload),
};
